import styled from "styled-components";
const A = styled.a`
  position: relative;
`

export default A;